import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import { Dialog, DialogContent, IconButton, Typography } from '@material-ui/core'
import styled, { css } from 'styled-components'

import LoginLink from '../../global/LoginLink'
import RegistrationLink from '../../global/RegistrationLink'

const buttonStyles = css`
  width: 100%;
  max-width: 379px;
  margin: 0 auto;
  text-transform: none;
  font-weight: 700;
  font-size: 1rem;
  border: 2px solid ${({ theme }) => theme.colors.brand.blue};
`

export const Modal = styled(Dialog)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  width: 100%;
  .MuiDialog-paper {
    width: 100%;
    max-width: 750px;
  }
  @media (min-width: 600px) {
    margin: 0 auto;
    position: relative;
  }
`

export const ModalContent = styled(DialogContent)`
  padding: 0 40px 40px 40px;
  margin: 0;
  @media (min-width: 600px) {
    padding: 0 80px 40px 80px;
  }
`

export const ModalStartTitle = styled.h3`
  color: #001b36;
  margin-bottom: 1.5rem;
`

export const ModalMessage = styled(Typography)`
  font-size: 16px;
  line-height: 19px;
  color: #001b36;
  margin-bottom: 32px;
  &:last-of-type {
    margin-bottom: 24px;
  }
`

export const ModalLogo = styled.img`
  width: 159px;
  height: 24px;
`

export const ModalBackIcon = styled(IconButton)`
  color: ${({ theme }) => theme.colors.grayscale.black};
  position: absolute;
  left: 12px;
  top: 12px;
  &.MuiIconButton-root:hover {
    background-color: inherit;
  }
`

export const ModalCloseIcon = styled(IconButton)`
  color: ${({ theme }) => theme.colors.grayscale.black};
  position: absolute;
  right: 12px;
  top: 12px;
  &.MuiIconButton-root:hover {
    background-color: inherit;
  }
`

export const ModalHeader = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  height: 73px;
`

export const LoginButtonLink = styled(LoginLink)(
  ({ theme }) => css`
    color: ${theme.colors.component.link};

    &:focus {
      outline: none;
    }
  `,
)

export const RegisterButtonLink = styled(RegistrationLink)(
  ({ theme }) => css`
    color: ${theme.colors.component.link};
    font-weight: inherit;
    letter-spacing: inherit;
    line-height: inherit;

    &:focus {
      outline: none;
    }
  `,
)

export const TicketSubmission = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const TicketSubmitButton = styled(SecondaryButton)`
  ${buttonStyles};
`

export const SelectGroup = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const TicketCreated = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 3rem;
`

export const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  margin-bottom: 25px;
`

export const CheckmarkCircleIcon = styled.img`
  display: block;
  max-width: 100%;
  margin-bottom: 25px;
`

export const FinishTicketButton = styled(SecondaryButton)`
  ${buttonStyles};
  margin-top: 5rem;
`

export const ModalFinishTitle = styled.h3`
  color: #001b36;
  margin-bottom: 2rem;
`
